import React from 'react';
import { Navigate } from 'react-router-dom';
import { isProgrammeEnabled } from './flag';

// Renders children only when the programmeEnabled feature flag is on.
const ProgrammeGate = ({ children }) => {
  if (!isProgrammeEnabled()) return <Navigate to="/" replace />;
  return children;
};

export default ProgrammeGate;